import React, { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  MsgError,
  MsgLoading,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import MetaService from "../../../services/MetaService";

export interface MetaFormInputType {
  route: string;
  title: string;
  description: string;
  keywords: string;
  img_url: string;
}

type PropsType = {
  activeItemId?: string;
  fetchMeta?: any;
};

const MetaForm = (props: PropsType) => {
  const [loading, setLoading] = useState<boolean>();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<MetaFormInputType>();
  const onSubmit: SubmitHandler<MetaFormInputType> = async (data) => {
    try {
      setLoading(true);
      MsgLoading();
      if (props.activeItemId) {
        const res = await MetaService.update(props.activeItemId, data);
        props.fetchMeta();
        MsgSuccess(res.data.message);
      } else {
        const res = await MetaService.create(data);
        MsgSuccess(res.data.message);
      }
    } catch (error: any) {
      if (error.response.data) {
        MsgError(error.response.data.message);
      }
    }
    setLoading(false);
  };

  const fetchPkgDetails = async (id: string) => {
    try {
      const res = await MetaService.fetchDetails(id);
      setValue("route", res.data.data.route);
      setValue("title", res.data.data.title);
      setValue("description", res.data.data.description);
      setValue("keywords", res.data.data.keywords);
      setValue("img_url", res.data.data.img_url);
    } catch (error: any) {
      if (error.response.data) {
        console.log(error.response.data);
      }
    }
  };

  useEffect(() => {
    if (props.activeItemId) {
      fetchPkgDetails(props.activeItemId);
    }
  }, [props]);
  return (
    <form action="" onSubmit={handleSubmit(onSubmit)} className="">
      <div className="flex flex-col space-y-3 my-4">
        <label htmlFor="route">Page route</label>
        <input
          type="text"
          id="route"
          className="form-input inputs"
          placeholder="Enter a page route"
          {...register("route", { required: true })}
        />
        {errors.route && (
          <span className="text-red-500">
            {errors.route.message || "This field is required"}
          </span>
        )}
      </div>

      <div className="flex flex-col space-y-3 my-4">
        <label htmlFor="title">Page title</label>
        <input
          type="text"
          id="title"
          className="form-input inputs"
          placeholder="Enter a page title"
          {...register("title", { required: true })}
        />
        {errors.title && (
          <span className="text-red-500">
            {errors.title.message || "This field is required"}
          </span>
        )}
      </div>

      <div className="flex flex-col space-y-3 my-4">
        <label htmlFor="description">Page description</label>
        <textarea
          id="description"
          rows={4}
          className="form-input inputs"
          placeholder="Enter a page description"
          {...register("description", { required: true })}
        ></textarea>

        {errors.description && (
          <span className="text-red-500">
            {errors.description.message || "This field is required"}
          </span>
        )}
      </div>

      <div className="flex flex-col space-y-3 my-4">
        <label htmlFor="keywords">Page keywords</label>
        <textarea
          id="keywords"
          rows={4}
          className="form-input inputs"
          placeholder="Enter a page keywords"
          {...register("keywords", { required: true })}
        ></textarea>
        {errors.keywords && (
          <span className="text-red-500">
            {errors.keywords.message || "This field is required"}
          </span>
        )}
      </div>

      <div className="flex flex-col space-y-3 my-4">
        <label htmlFor="img_url">Page img_url</label>
        <input
          type="text"
          id="img_url"
          className="form-input inputs"
          placeholder="Enter a page img_url"
          {...register("img_url", { required: true })}
        />
        {errors.img_url && (
          <span className="text-red-500">
            {errors.img_url.message || "This field is required"}
          </span>
        )}
      </div>

      <div className="my-4">
        <input
          type="submit"
          value={loading ? "Loading" : "Submit"}
          disabled={loading}
          className="btn btn-primary"
        />
      </div>
    </form>
  );
};

export default MetaForm;
